export default __webpack_public_path__ + "static/media/cc8485d8bf76871ae19c9c1293ea41fb.svg";